// extracted by mini-css-extract-plugin
export default {"autocompleteInput":"AddressLookupField__autocompleteInput--1Vn","toggleManualInput":"AddressLookupField__toggleManualInput--1LY"};